 (function () {
  const params = new URLSearchParams(window.location.search);
  const logId = params.get('pro_cart');
  const ref = params.get('rfsn');
  async function dqResolveHsIdFromRfsn(rfsn) {
    if (!rfsn) return '';

    try {
      const response = await fetch(
        'https://api.dermaquestclinical.com/cart-builder-resolve-hs.php?rfsn=' + encodeURIComponent(rfsn)
      );

      const result = await response.json();

      if (!response.ok || result.success === false) {
        return '';
      }
      const hsId = result.hs_id || '';
      if (hsId) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              referral_code: rfsn,
              hs_id: hsId
            }
          })
        });
      }

      return hsId;

    } catch (error) {
      console.error('Unable to resolve hs_id from rfsn:', error);
      return '';
    }
  }  
  if (!logId && ref) {
    dqResolveHsIdFromRfsn(ref);
    return;
  }

  if (!logId) return;

  const endpoint = `https://api.dermaquestclinical.com/cart-builder-fetch.php?log_id=${encodeURIComponent(logId)}`;

  async function dqClearCart() {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  function showDqCartReadyModal(count) {
    let modal = document.querySelector('#dq-success-modal');

    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'dq-success-modal';
      modal.className = 'dq-success-modal';
      document.body.appendChild(modal);
    }

    modal.innerHTML = `
      <div class="dq-success-modal__card" role="dialog" aria-modal="true">
        <div class="dq-success-modal__icon">✓</div>

        <h3>Processing Cart Data</h3>

        <p>
          Your DermaQuest product selection has being added to your cart. <br>Redirecting to your cart in a few seconds.
        </p>

        <div class="dq-success-modal__actions">
          
          <button type="button" data-dq-success-close>
            Continue Shopping
          </button>
        </div>
      </div>
    `;

    requestAnimationFrame(() => {
      modal.classList.add('is-active');
    });

    modal.querySelector('[data-dq-success-close]').onclick = function () {
      modal.classList.remove('is-active');

      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    };
  }

  async function dqAddItems(items, referralCode, hsId) {

    const attributes = {
      referral_code: referralCode || ''
    };

    if (hsId) {
      attributes.hs_id = hsId;
    }

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes
      })
    });

    const payload = {
      items: items.map(item => ({
        id: Number(item.variant_id),
        quantity: Number(item.quantity || 1),
        properties: {
          _referral_code: referralCode || ''
        }
      }))
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    // TEST ONLY
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: 'AFFILIATE10'
      })
    });

    fetch('/discount/AFFILIATE10')
  .then(() => fetch('/cart.js'))
  .then(r => r.json())
  .then(console.log);

    return response;
}

  async function dqBuildCartFromLog() {
    try {
      document.documentElement.classList.add('dq-builder-loading-cart');

      const response = await fetch(endpoint);
      const result = await response.json();

      if (!response.ok || result.success === false) {
        throw new Error(result.message || 'Unable to load product selection.');
      }

      const products = result.products || [];

      if (!products.length) {
        throw new Error('No products found.');
      }

      const referralCode = ref || result.referral_code || '';
      const hsId = result.hs_id || '';

      await dqClearCart();
      await dqAddItems(products, referralCode, hsId);
      await new Promise(resolve => setTimeout(resolve, 800));

      document.documentElement.classList.remove('dq-builder-loading-cart');
      showDqCartReadyModal(products.length);

      

      window.location.href = '/discount/AFFILIATE10?redirect=/cart&rfsn=' + referralCode;
    } catch (error) {
      console.error('DermaQuest cart builder error:', error);
      alert(error.message || 'Unable to build cart.');
    } finally {
      document.documentElement.classList.remove('dq-builder-loading-cart');
    }
  }

  dqBuildCartFromLog();
})();